import { useContext, useState } from "react";
import { useAppLoading } from "../../components/layout/app-loading-provider";
import { CognitoContext } from "../../contexts/cognito/cognito-provider";
import { CoreServiceSelector } from "../../services/core/service-selector";
import { getRedemptionErrorMessage } from "../../utils/redemption-errors";
import CardComponent from "../common/card-component";
import FixedBottomButton from "../form/FixedBottomButton";
import { PrimaryButton } from "../form/primary-button";
import { SecondaryButton } from "../form/secondary-button";

export const RedeemCertificateVoucher = ({
  dataModel,
  transactionGroupId,
  serviceDispatcher,
  onRedeemSuccess,
  otherButtons,
  otherPanels,
  onError,
  onUnauthorised,
  onUseAnotherVoucher
}) => {
  const { state, dispatch } = useContext(CognitoContext);
  const { showLoading, hideLoading } = useAppLoading();
  const currentBalance = (dataModel.voucher && dataModel.voucher.Balance) || 0;
  const remaining = (
    0,
    (dataModel.totalBillAmount || 0) - (dataModel.voucher?.Balance || 0)
  );

  const [formState, setFormState] = useState({
    isProcessing: false,
    totalBillAmount: 0,
    transactionGroupId,
  });

  const newModel = {
    ...dataModel,
    ProductName: dataModel.voucher.ProductName,
    amount: dataModel.voucher.Balance,
  };
  const [model] = useState(newModel || {});

  const redeemCard = async () => {
    let service = null;
    showLoading();
    if (serviceDispatcher && typeof serviceDispatcher === "function")
      service = await serviceDispatcher();
    else service = CoreServiceSelector.GetRedemptionService(state.session);

    setFormState({
      ...formState,
      isProcessing: true,
    });

    service
      .redeemCard({
        CompanyId: model.companyId,
        CardNumber: model.cardNumber,
        PinCode: model.pinCode,
        Amount: model.amount,
        TotalBillAmount: model.totalBillAmount,
        TransactionGroupId: formState.transactionGroupId,
      })
      .then((result) => {
        setFormState({
          ...formState,
          isProcessing: false,
        });

        hideLoading();
        if (result.Success) {
          onRedeemSuccess &&
            onRedeemSuccess({
              redeemedAmount: result.Amount,
              transactionGroupId: result.TransactionGroupId,
            });
        } else {
          onError &&
            onError({
              errorMessage: getRedemptionErrorMessage(result),
            });
        }
      })
      .catch((err) => {
        hideLoading();

        onUnauthorised &&
          err &&
          err.response &&
          err?.response?.status === 401 &&
          onUnauthorised();

        setFormState({
          ...formState,
          isProcessing: false,
        });

        onError &&
          onError({
            errorMessage: getRedemptionErrorMessage(err.response?.data),
          });
      });
  };

  const onSubmitRedemption = (event) => {
    event.preventDefault();
    setFormState({
      ...formState,
      isProcessing: true,
    });
    redeemCard();
  };

  return (
    <>
      <div>

        <form>
          <div className="mb-3 mt-[20vh]">
            <div className="w-full flex justify-center mt-10 ">
              <CardComponent
                cardText={`${dataModel?.cardNumber || ""}`}
                amountText={`$ ${currentBalance?.toFixed(2)}`}
              />
            </div>
            <label
              className="text-center w-full font-headings-primary font-medium text-[28px] leading-[33.6px] mb-2 mt-[2.5rem]"
              htmlFor="amount"
            >
              Redeem certificate
            </label>
            {remaining < 0 && (
              <div>
                <p className="text-center mt-2 text-[16px] font-body-primary text-white z-[100]">
                  This certificate covers more than the total bill.<br />
                  As certificates are single-use, any unused value can’t be carried over.
                </p>
              </div>
            )}
          </div>

          <div>{otherPanels}</div>
          <FixedBottomButton>
            <PrimaryButton
              type="submit"
              className="mt-5"
              onClick={onSubmitRedemption}
            >
              Redeem certificate
            </PrimaryButton>
            <SecondaryButton
              onClick={onUseAnotherVoucher}
              className="mx-auto mt-4"
            >
              Redeem another card/certificate
            </SecondaryButton>
          </FixedBottomButton>
        </form>
      </div>
    </>
  );
};
